export const VIOLATION_TYPES = {
  CLOCK_IN: 'CLOCK_IN',
  CLOCK_OUT: 'CLOCK_OUT',
  BREAK: 'BREAK',
  SHIFT: 'SHIFT',
  MISSED: 'MISSED',
  TOTAL: 'TOTAL',
};

export const GROUPED_VIOLATION_SUBTYPES = {
  breakViolations: 'BREAK_VIOLATIONS',
  missedShifts: 'MISSED_SHIFTS',
  clockViolations: 'CLOCK_VIOLATIONS',
};

export const METRICS_TITLES = [
  {
    id: 'total',
    label: 'Total violations',
    type: 'ALL',
    code: 'ALL',
    order: 0,
    formatter: (value) => value,
  },
  {
    id: 'break_violations',
    label: 'Break Violations',
    type: 'BREAK',
    code: 'BREAK_VIOLATIONS',
    order: 1,
    formatter: (value) => value,
  },

  {
    id: ' clock_violations',
    label: ' Clock Violations',
    type: 'SHIFT',
    code: 'CLOCK_VIOLATIONS',
    order: 2,
    formatter: (value) => value,
  },
  {
    id: 'Missed Shifts',
    label: 'Missed Shifts',
    type: 'SHIFT',
    code: 'MISSED_SHIFTS',
    order: 3,
    formatter: (value) => value,
  },
];

export const TABLE_TITLES = [
  { id: 'displayName', label: 'Employees' },
  { id: 'type.message', label: 'Violation' },
  { id: 'status', label: 'Status' },
  { id: 'timestamp', label: 'Date' },
];
